import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { selectedUserIdsAtom, selectedTagIdsAtom, approvalFilterAtom, searchQueryAtom } from '../state/filterAtoms';

export function useDocumentFilters() {
    const [selectedUserIds, setSelectedUserIds] = useAtom(selectedUserIdsAtom);
    const [selectedTagIds, setSelectedTagIds] = useAtom(selectedTagIdsAtom);
    const [approvalFilter, setApprovalFilter] = useAtom(approvalFilterAtom);
    const [searchQuery, setSearchQuery] = useAtom(searchQueryAtom);

    const clearFilters = useCallback(() => {
        setSelectedUserIds([]);
        setSelectedTagIds([]);
        setApprovalFilter('pending');
        setSearchQuery('');
    }, [setSelectedUserIds, setSelectedTagIds, setApprovalFilter, setSearchQuery]);

    return {
        selectedUserIds,
        setSelectedUserIds,
        selectedTagIds,
        setSelectedTagIds,
        approvalFilter,
        setApprovalFilter,
        searchQuery,
        setSearchQuery,
        clearFilters,
    };
}
